/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum MarketColumns {
    MSA = 'msa',
    STATE = 'state',
    CITY = 'city',
    ZIP_CODE = 'zip_code',
    GEOGRAPHY = 'geography',
}
